import { Injectable } from '@angular/core';

import { BridgeService } from '../bridge/bridge.service';

export interface UnsubscribeDetails {
    email: string;
    preferences: EmailPreference[];
}

export interface EmailPreference {
    orgId?: string;
    eventType?: string;
    subscriptionId?: string;
    displayName?: string;
}

export interface UnsubscribeRequest {
    token: string;
    email: string;
    preference: 'COMPLETE' | 'SUBSCRIPTION_LEVEL' | 'EVENT_TYPE_LEVEL' | 'ORGANIZATION_NOTIFICATIONS';
}

export interface DeletePreferenceRequest {
    orgId: string;
    eventType: string;
    subscriptionId: string;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationPreferencesService {
    constructor(private _bridge: BridgeService) {}

    /**
     * Get unsubscribe details by token (public endpoint)
     */
    getUnsubscribeDetails = (token: string) => {
        return new Promise<UnsubscribeDetails>((resolve, reject) => {
            this._bridge.getUnsubscribeDetails(
                token,
                res => {
                    resolve(res);
                },
                res => {
                    reject(res);
                }
            );
        });
    };

    /**
     * Unsubscribe email by token (public endpoint)
     */
    unsubscribeByEmail = (data: UnsubscribeRequest) => {
        return new Promise((resolve, reject) => {
            this._bridge.unsubscribeByEmail(
                data,
                res => {
                    resolve(res);
                },
                res => {
                    reject(res);
                }
            );
        });
    };

    /**
     * Get email preferences for logged-in user (authenticated)
     */
    getEmailPreferences = () => {
        return new Promise<EmailPreference[]>((resolve, reject) => {
            this._bridge.getEmailPreferences(
                res => {
                    resolve(res);
                },
                res => {
                    reject(res);
                }
            );
        });
    };

    /**
     * Delete email preferences for logged-in user (authenticated)
     */
    deleteEmailPreferences = (data: DeletePreferenceRequest[]) => {
        return new Promise((resolve, reject) => {
            this._bridge.deleteEmailPreferences(
                data,
                res => {
                    resolve(res);
                },
                res => {
                    reject(res);
                }
            );
        });
    };
}
